import * as React from 'react';
import { DisplayCodes } from 'ui';
import { DisplayCodesProps } from 'ui/display-codes/display-codes';

export const DisplayCodesUnitOfMeasure = (props: DisplayCodesProps) => 
  <DisplayCodes {...props} label={{...props.label, visible: false}}/>;
